<template>
    <div>
      <template v-if="crew.active == 1 || isSystemAdmin">
        <button class="btn btn-sm btn-outline-primary font-weight-bolder my-auto"
                data-toggle="modal"
                data-target="#upload-covid-vaccine"
        >
          <span class="fas fa-file-medical"></span>
          Add Covid Vaccine Record
        </button>
      </template>

        <cms-modal unique="upload-covid-vaccine" title="Upload Covid Vaccine Record" size="xl">

            <div class="row">
                <form class="col col-4 border-right" @submit.prevent="confirmAddCovidVaccine">
                    <div class="form-group form-row mb-1" :class="{'has-error': newCovidVaccineErrors.vaccine_brand_id}">
                        <label for="new-vaccine-brand" class="col col-sm-6 col-form-label font-weight-bolder">
                            Vaccine Brand:
                        </label>
                        <div class="col col-sm-11 offset-1 col-form-label p-0">
                            <select id="new-vaccine-brand" class="form-control form-control-xs" required
                                    v-model="newCovidVaccine.vaccine_brand_id"
                            >
                                <option :value="undefined">--- Select Vaccine Brand ---</option>
                                <option v-for="vaccineBrandKey in vaccineBrandKeys" :key="vaccineBrandKey.id"
                                        :value="vaccineBrandKey.id"
                                >
                                    {{ vaccineBrandKey.name }}
                                </option>
                            </select>
                            <span class="help-block" v-if="newCovidVaccineErrors.vaccine_brand_id !== ''">
                              <small><strong>{{ newCovidVaccineErrors.vaccine_brand_id }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': newCovidVaccineErrors.inoculate_date}">
                        <label for="new-vaccine-date" class="col col-sm-6 col-form-label font-weight-bolder">
                            Inoculate Date:
                        </label>
                        <div class="col col-sm-11 offset-1 col-form-label p-0">


                            <input type="date" id="new-vaccine-date"
                                   class="form-control form-control-xs"
                                   required
                                   v-model="newCovidVaccine.inoculate_date"
                            >
                            <span class="help-block" v-if="newCovidVaccineErrors.inoculate_date !== ''">
                              <small><strong>{{ newCovidVaccineErrors.inoculate_date }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': newCovidVaccineErrors.dose_2 }">
                        <label for="new-vaccine-dose2" class="col col-sm-12 col-form-label font-weight-bolder">
                            Dose 2 Required for this Brand?
                        </label>

                        <div class="col col-sm-11">
                            <div class="form-check d-block">
                                <label class="form-check-label text-left"
                                       for="new-vaccine-dose2"
                                >
                                  Check box, if YES:
                                </label>
                              <input class="form-check-input mx-2 mt-1" type="checkbox" id="new-vaccine-dose2"
                                     required
                                     v-model="newCovidVaccine.dose_2" :disabled="newCovidVaccine.is_booster || newCovidVaccine.vaccine_brand_id===7"
                              >
                            </div>
                            <span class="help-block" v-if="newCovidVaccineErrors.dose_2 !== ''">
                                <small><strong>{{ newCovidVaccineErrors.dose_2 }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': newCovidVaccineErrors.completion_date}">
                        <label for="new-vaccine-date" class="col col-sm-10 col-form-label font-weight-bolder">
                            Completion Date (2nd Dose):
                        </label>
                        <div class="col col-sm-11 offset-1 col-form-label p-0">

                            <input type="date" id="new-completion-date"
                                   class="form-control form-control-xs"
                                   :disabled="!newCovidVaccine.dose_2"
                                   v-model="newCovidVaccine.completion_date"
                                   required
                            >
                            <span class="help-block" v-if="newCovidVaccineErrors.completion_date !== ''">
                              <small><strong>{{ newCovidVaccineErrors.completion_date }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': newCovidVaccineErrors.is_booster }">
                      <label for="new-vaccine-booster" class="col col-sm-12 col-form-label font-weight-bolder">
                        Is this Booster Shot?
                      </label>

                      <div class="col col-sm-11">
                        <div class="form-check d-block">
                          <label class="form-check-label text-left"
                                 for="new-vaccine-booster"
                          >
                            Check box, if YES:
                          </label>
                          <input class="form-check-input mx-2 mt-1" type="checkbox" id="new-vaccine-booster"
                                 v-model="newCovidVaccine.is_booster" :disabled="newCovidVaccine.dose_2"
                          >
                        </div>
                        <span class="help-block" v-if="newCovidVaccineErrors.is_booster !== ''">
                                  <small><strong>{{ newCovidVaccineErrors.is_booster }}</strong></small>
                              </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': newCovidVaccineErrors.country_id}">
                        <label for="new-vaccine-country" class="col col-sm-6 col-form-label font-weight-bolder">
                            Administering Country:
                        </label>
                        <div class="col col-sm-11 offset-1 col-form-label p-0">
                            <select id="new-vaccine-country" class="form-control form-control-xs"
                                    required
                                    v-model="newCovidVaccine.country_id"
                            >
                                <option :value="undefined">--- Select Country ---</option>
                                <option v-for="countryKey in countryKeys" :key="countryKey.id"
                                        :value="countryKey.id"
                                >
                                    {{ countryKey.name }}
                                </option>
                            </select>
                            <span class="help-block" v-if="newCovidVaccineErrors.country_id !== ''">
                              <small><strong>{{ newCovidVaccineErrors.country_id }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': newCovidVaccineErrors.vaccineFile}">
                        <label for="new-vaccine-file" class="col col-sm-6 col-form-label font-weight-bolder">
                            Vaccine File:
                        </label>
                        <div class="col col-sm-11 offset-1 col-form-label p-0">
                            <input type="file" id="new-vaccine-file" required
                                   class="form-control form-control-xs"
                                   accept="application/pdf"
                                   @change="updateFileFrame('new-vaccine')"
                            >
                            <span class="help-block" v-if="newCovidVaccineErrors.vaccineFile !== ''">
                              <small><strong>{{ newCovidVaccineErrors.vaccineFile }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <hr />

                    <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder float-right">
                        <span class="fas fa-plus"></span>
                        Save
                    </button>



                </form>
                <div class="col col-4">
                    <cms-file-frame
                        frame-id="new-vaccine"
                        :file-string="vaccineFileString"
                        :prompt="vaccineFilePrompt"
                        :frame-height="600"
                    ></cms-file-frame>
                </div>
            </div>


        </cms-modal>

    </div>
</template>

<script>
/* eslint-disable */
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { vesselMixin } from "@/mixins/vesselMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters} from "vuex";
import { FileService } from "@/services/FileService";

import CmsFileFrame from "@/components/elements/CmsFileFrame";
import CmsModal from "@/components/elements/CmsModal";
import { FILE_SIZE_UPLOAD_LIMIT } from "@/services/ConstantService";

export default {
    name: "AddCovidVaccine",

    mixins: [ vueAppMixin, formMixin, vesselMixin, gateMixin ],

    components: { CmsModal, CmsFileFrame },

    data() {
        return {
            newCovidVaccine: {},
            newCovidVaccineErrors: {},
            vaccineFileString: '',
            vaccineFilePrompt: '',
            editableFields: [
                'inoculate_date',
                'completion_date',
                'country_id',
                'vaccine_brand_id'
            ]
        }
    },

    methods: {
        ...mapActions([
            'uploadCovidVaccine'
        ]),

        async confirmAddCovidVaccine() {
            if(await this.confirmCreateAlert()) {
                let formData = new FormData();
                formData.append('crew_id', this.crew.id);

                this.editableFields.forEach(key => {
                    let value = this.newCovidVaccine[key] ? this.newCovidVaccine[key] : '';
                    if(value === '0000-00-00') value = '';
                    formData.append(key, value);
                });
                formData.append('dose_2', this.newCovidVaccine.dose_2 ? 1 : 0);
                formData.append('is_booster', this.newCovidVaccine.is_booster ? 1 : 0);

                let vaccineFile = document.getElementById('new-vaccine-file');
                if(vaccineFile && vaccineFile.files[0]) {
                    formData.append('vaccineFile', vaccineFile.files[0]);
                }
                let newCovidVaccine = await this.uploadCovidVaccine(formData);
                if(newCovidVaccine) {
                    if(newCovidVaccine.errors) {
                        this.newCovidVaccineErrors = newCovidVaccine.errors;
                    } else {
                        this.successAlert('Covid Vaccine Record Successfully Uploaded', 'UPLOAD');
                        document.getElementById('close-upload-covid-vaccine').click();
                    }
                }
            }
        },

        updateFileFrame(inputId) {
            let input = document.getElementById(`${inputId}-file`);
            if (input.files && input.files[0]) {
                if(input.files[0].size > FILE_SIZE_UPLOAD_LIMIT) {
                    this.vaccineFilePrompt = 'FILE TOO LARGE';
                    this.vaccineFileString = '';
                    return;
                } else {
                    this.vaccineFilePrompt = '';
                    let vaccineFileString = '';
                    let reader = new FileReader();
                    reader.onload = e => vaccineFileString = e.target.result
                    reader.readAsDataURL(input.files[0]);
                    setTimeout(() => {
                        this.vaccineFileString = FileService.base64FileToBlobUrl(vaccineFileString);
                    }, 500);
                }
            } else {
                this.vaccineFileString = '';
            }
        },
    },

    computed: {
        ...mapGetters([
            'vaccineBrandKeys',
            'countryKeys',
            'crew'
        ])
    },
  watch:{
      'newCovidVaccine.vaccine_brand_id'(){
        if(this.newCovidVaccine.vaccine_brand_id === 7){
          this.newCovidVaccine.dose_2=false;
        }
      }
  }

}
</script>

<style scoped>

</style>
